import { CustomBuilderComponents } from '@/helpers/enums';
import { LocaleEnum, localizedBuilderProductData } from '@/helpers/enums';

const localesArr = [];
for (const [_key, value] of Object.entries(LocaleEnum)) {
  localesArr.push(value);
}

// set localizeRef for product data model
let localizedRefId = localizedBuilderProductData[LocaleEnum.EN_US];
// only run client side
if (typeof window !== 'undefined') {
  localesArr.forEach(locale => {
    if (window.location.pathname.indexOf(`/${locale}`) === 0) {
      localizedRefId = localizedBuilderProductData[locale];
      return;
    }
  });
}

export const productMainBuilderConfigs = {
  name: CustomBuilderComponents.PRODUCT_MAIN,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/details-more.svg',
  inputs: [
    {
      name: 'Admin Tips',
      type: 'adminTips',
      defaultValue:
        'Select product details you would like to show on this page',
    },
    {
      name: 'productDetails',
      type: 'reference',
      modelId: localizedRefId,
      required: true,
    },
    {
      name: 'productDetailsLeft',
      friendlyName: 'Previous Product',
      type: 'reference',
      modelId: localizedRefId,
      required: true,
    },
    {
      name: 'productDetailsRight',
      friendlyName: 'Next Product',
      type: 'reference',
      modelId: localizedRefId,
      required: true,
    },
  ],
};
